import { MenuItem, Select, SelectProps } from '@mui/material';
import { graphql } from '../../../../gql';
import { useApiQuery } from '../../../../query/hooks';
import { forwardRef } from 'react';

const listTeamsQuery = graphql(`
	query organization_members_listTeams {
		listTeam {
			id
			name
		}
	}
`);

const TeamSelect = forwardRef<HTMLElement, Omit<SelectProps<string | null>, 'variant'>>((props, ref) => {
	const { isLoading, data } = useApiQuery(listTeamsQuery);

	const finalProps = {
		...props,
		disabled: isLoading || props.disabled,
		placeholder: isLoading ? 'Loading...' : props.placeholder,
	};

	return (
		<Select {...finalProps} ref={ref}>
			{data?.listTeam.map((team) => (
				<MenuItem key={team.id} value={team.id}>
					{team.name}
				</MenuItem>
			))}
		</Select>
	);
});

export { TeamSelect };
